module.exports = __webpack_public_path__ + "img/no-access.c4473bf0.png";